import { Link } from "@tanstack/react-router";
import { useOrgRole } from "../lib/org";
import { cn } from "../lib/utils";
import { useEnv } from "./env";

/**
 * Hint where the editor offers brand colours, text styles and logos while the
 * organization has no brand kit yet (docs/06-brand-kit.md).
 */
export function NoBrandKitHint({ className }: { className?: string }) {
  const env = useEnv();
  const { can } = useOrgRole(env.orgId);
  const link = (
    <Link
      to="/o/$orgId/brand"
      params={{ orgId: env.orgId }}
      className="font-medium text-brand-700 hover:underline"
    >
      „Marke“
    </Link>
  );
  return (
    <p className={cn("text-xs text-zinc-500", className)}>
      {can("brand.update") ? (
        <>Noch kein Brand Kit – in {link} anlegen</>
      ) : (
        <>Noch kein Brand Kit – Owner und Admins legen es in {link} an</>
      )}
    </p>
  );
}
